module.exports = __webpack_public_path__ + "static/media/blank_2_3.bf8f4c8c.png";